module.exports = {
	"base": {
		"welcome": "Bine ai venit la Mulligans, %{name}!",
		"user": "Info utilizator",
		"devices": "Dispozitive",
		"refunds": "Rambursări",
		"resources": "Resurse",
		"transactions": "Comenzi & Retururi",
		"email": "Email",
		"password": "Parolă",
		"save": "Salvare",
		"sign-out": "Deconectare",
		"cancel": "Anulare",
		"close": "Închidere",
		"learn-more": "Află mai multe",
		"required": "Obligatoriu",
		"support": "Asistență",
		"bookshelf": "Bookshelf",
		"launch": "Lansare",
		"download": "Descărcare",
		"details": "Detalii",
		"cannot-be-blank": "%{field} nu poate fi gol.",
		"saving": "Se salvează...",
		"done": "Finalizat",
		"failed": "Nu a reușit",
		"copy": "Copiere"
	},
	"signin": {
		"login-failure": "E-mailul sau parola este greșită",
		"welcome-large": "Bine ai venit la  <span class='inner'>%{brand} Account Center</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Conectare",
		"forgot-password": "Parolă uitată",
		"new-to-vst": "Îți este nou %{brand}?",
		"create-account": "Creează un cont",
		"signing-in": "Autentificare în curs...",
		"signin-failed": "Autentificare eșuată"
	},
	"transactions": {
		"price": "Preț",
		"excluded": "(Fără taxe)",
		"quantity": "Cantitate",
		"confirmation#": "# confirmare",
		"payment": "Plată",
		"purchased": "Achiziţionat(e)",
		"purchase-details": "Detalii achiziţie",
		"subtotal": "Sub",
		"total": "Total",
		"tax": "Impozit",
		"loading": "Se încarcă tranzacțiile tale...",
		"no-purchases": "Nu ai achiziții.",
		"seller-vat": "TVA comerciant",
		"total-vat": "%{vat} total achitat",
		"portion": "%{subTax} Taxă %{rate}%",
		"vat-disclosure": "Prețul include %{vat}",
		"purchases": "Achiziţii",
		"refunded-items": "Articole rambursate",
		"book-title": "Titlu carte",
		"refund-details": "Detalii rambursare",
		"print-receipt": "Tipărire chitanță",
		"request-refund": "Solicitare rambursare",
		"expired": "Expirat",
		"expires-in": "Expiră la %{date}",
		"details-refund": "Detalii și rambursare",
		"modal": {
			"cant-refund-title": "Rambursare nedisponibilă",
			"cant-refund": "Cartea nu poate fi rambursată din unul sau mai multe dintre următoarele motive.",
			"cant-refund-1": "S-a vizualizat prea mult din conținutul cărții.",
			"cant-refund-2": "A trecut mai mult de 14 zile de la data achiziției.",
			"cant-refund-3": "Codul tău de resurse online a fost afișat.",
			"cant-refund-4": "Cartea ta a fost rambursată anterior.",
			"cant-refund-5": "Toate codurile au fost revendicate și/sau rambursate deja.",
			"cant-refund-6": "Au trecut mai mult de 30 de zile de la data achiziției.",
			"cant-refund-support": "Dacă ai nedumeriri privind politica de rambursare %{brand}, contactează <a href='%{support_url}' target='_blank'>serviciul de asistență</a>."
		},
		"license": {
			"perpetual": "Accesul online nu expiră",
			"days": "Acces pentru %{days} zi"
		}
	},
	"devices": {
		"description": "%{brand} îţi permite să ai <span>%{desktop}</span> computere şi <span>%{mobile}</span> dispozitive mobile/tablete activate la orice moment.",
		"loading": "Salut, îți obținem dispozitivele :)",
		"no-active": "Nu ai dispozitive active.",
		"deactivate": "Dezactivare"
	},
	"user": {
		"personal-information": "Informaţii personale",
		"security-information": "Informații de securitate",
		"notifications": "Notificări",
		"first-name": "Prenume",
		"last-name": "Nume de familie",
		"change-password-title": "Modificare parolă",
		"current-password": "Parolă curentă",
		"new-password": "Parolă nouă",
		"security-password": "Parolă",
		"confirm-new-password": "Confirmare parolă nouă",
		"security-question": "Întrebare de securitate",
		"security-info-change": "Modificare",
		"question": "Întrebare",
		"answer": "Răspuns",
		"notifications-text": "Trimiteți-mi pe e-mail actualizări efectuate ocazional privind activitatea contului meu, actualizări ale produsului și oferte speciale.",
		"loading": "Spot caută informațiile tale de utilizator, durează puțin timp 🐶",
		"change-password-text": "Parola trebuie să conțină cel puțin 8 caractere, o literă mare, o literă mică și un caracter special.",
		"email-locked": "E-mail blocat",
		"email-locked-description": "Nu ai acces să modifici e-mailul tău.",
		"email-locked-more": "Contactează administratorul tău.",
		"security-question6": "Care este sportul tău preferat?",
		"security-question7": "Ce aromă de înghețată preferi?",
		"security-question8": "Care este animalul de casă preferat?",
		"security-question9": "Ce îți doreai să devii când erai mic?",
		"security-question10": "Cum se numea profesorul/ profesoara tău/ta preferat/ă?",
		"new-password-failure": "Parola nu îndeplinește cerințele",
		"confirm-password-failure": "Parola trebuie să corespundă",
		"new-password-tooltip": "Trebuie să conțină cel puțin 8 caractere, o literă mare, o literă mică și un caracter special.",
		"enter-valid-email": "Introdu o adresă de e-mail validă.",
		"password-cannot-be-same": "Parola nu poate fi aceeași precum cea anterioară.",
		"incorrect-password": "Parolă greșită",
		"complete-account": "Se pare că trebuie să <a href='%{href}'>finalizați contul dvs</a>.",
		"completing-allows": "După finalizarea contului puteți citi cărți offline pe aplicațiile noastre pentru dispozitive mobile și puteți partaja note și evidențieri cu prietenii.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Auxiliare",
		"access-codes": "Coduri de acces",
		"print-on-demand": "Imprimare la cerere",
		"check-pod": "Verifică opţiunile de tipărire ale editurilor pentru cărţile tale.",
		"check-now": "Verificare acum",
		"loading": "Așteaptă, îți actualizăm resursele!",
		"in": "în",
		"access-code-intro": "Un cod de acces este o parolă pe care o utilizezi pentru a accesa conținut de curs online. După ce afișezi un cod pentru un articol, nu îl vei putea returna. Pentru instrucţiuni suplimentare privind utilizarea codurilor tale de acces, accesează <a href='%{support_url}' target='_blank'>secţiunea de asistenţă</a>.",
		"expires": "Expiră",
		"expiration-message": "Conține instrucțiuni privind utilizarea codurilor tale de acces.",
		"copy-fail": "Nu se poate copia. Selectează codul și copiază-l manual.",
		"launch-site": "Lansare site",
		"launch-book": "Lansare carte",
		"reveal-code": "Afişare cod",
		"no-resources": "Nu ai resurse.",
		"no-access-codes": "Nu ai coduri de acces.",
		"no-ancillaries": "Nu există elemente auxiliare pentru acest titlu",
		"name": "Nume",
		"type": "Tip",
		"size": "Dimensiune",
		"download-all": "Descărcare toate",
		"back": "Înapoi la resurse"
	},
	"refunds": {
		"states": {
			"refunded": "Rambursat",
			"unavailable": "Rambursare nedisponibilă"
		},
		"reasons": {
			"dropped": "Am renunțat la curs",
			"wrong": "Cartea era greșită pentru cursul meu",
			"print": "Am decis să achiziționez o versiune tipărită",
			"missing": "Cartea nu conține tot ce am nevoie pentru cursul meu (ex. un CD, acces online, videoclipuri)",
			"other": "Altele"
		},
		"bulk": {
			"policy": "Făcând clic pe butonul „Finalizare rambursare” de mai jos, sunt de acord cu politica %{brand} <a href='%{policy_url}' target='_blank'>privind rambursările</a>.",
			"complete": "Finalizare rambursare",
			"view-details": "Vizualizare detalii rambursare",
			"success": "Rambursarea ta a fost solicitată. Te rugăm să aștepți 48 de ore pentru a fi prelucrată.",
			"failure": "Hopa - a apărut o problemă! Din nefericire, rambursarea nu a fost procesată.",
			"retry": "Încearcă din nou",
			"support": "Contactați centrul de asistență",
			"available-codes": "Coduri disponibile",
			"codes-selected": "Coduri selectate",
			"download": "Descărcare coduri",
			"partially-refunded": "Rambursat(ă) parțial",
			"pick-one": "Trebuie să selectezi cel puțin un cod pentru a efectua o rambursare"
		},
		"refund": "Rambursare",
		"all": "Rambursare toate?",
		"missing-reason": "Trebuie să selectezi un motiv pentru a continua",
		"missing-elaboration": "Te rugăm să elaborezi",
		"policy": "Făcând clic pe butonul Complete Refund Request (Finalizare solicitare rambursare) de mai jos, înțeleg că dacă achiziționez din nou acest manual în format electronic de la %{brand}, nu voi putea solicita alte rambursări pentru același manual în format electronic. Vizualizează politica completă privind rambursările.",
		"refunded": "Rambursat",
		"sorry": "Ne pare rău că nu ai fost mulțumit de achiziție.",
		"error": "A apărut o problemă",
		"error-explain": "Nu putem procesa rambursarea ta. Încearcă din nou.",
		"why": "Ne poți spune de ce?",
		"no-refunds": "Nu ai articole rambursate.",
		"select-codes": "Selectează codul/codurile pentru rambursare:",
		"number": "Câte?",
		"back": "Înapoi la rambursări"
	},
	"purchases": {
		"back": "Înapoi la achiziții"
	},
	"global-bar": {
		"account": "Setări cont"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/ro.json
 ** module id = 996
 ** module chunks = 0
 **/